import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-count-star.tsx
/**
* icon.24.count-star
*
* Keywords: asterisk, radial, center, expand, burst, symmetrical, eight-pointed, snowflake
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTIuNSA2YS41LjUgMCAwIDAtMSAwdjQuNzkzbC0zLjM4OS0zLjM5YS41LjUgMCAwIDAtLjcwNy43MDhsMy4zODkgMy4zODlINmEuNS41IDAgMCAwIDAgMWg0Ljc5M2wtMy4zOSAzLjM5YS41LjUgMCAxIDAgLjcwOC43MDZsMy4zODktMy4zODlWMThhLjUuNSAwIDAgMCAxIDB2LTQuNzkzbDMuMzkgMy4zOWEuNS41IDAgMSAwIC43MDYtLjcwOEwxMy4yMDcgMTIuNUgxOGEuNS41IDAgMCAwIDAtMWgtNC43OTNsMy4zOS0zLjM5YS41LjUgMCAxIDAtLjcwOC0uNzA2TDEyLjUgMTAuNzkzeiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-8261
*/
const Icon24CountStar = memo(function Icon24CountStar(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M12.5 6a.5.5 0 0 0-1 0v4.793l-3.389-3.39a.5.5 0 0 0-.707.708l3.389 3.389H6a.5.5 0 0 0 0 1h4.793l-3.39 3.39a.5.5 0 1 0 .708.706l3.389-3.389V18a.5.5 0 0 0 1 0v-4.793l3.39 3.39a.5.5 0 1 0 .706-.708L13.207 12.5H18a.5.5 0 0 0 0-1h-4.793l3.39-3.39a.5.5 0 1 0-.708-.706L12.5 10.793z",
			clipRule: "evenodd"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M11.5 5a.5.5 0 0 1 .5.5v4.793l3.39-3.39a.5.5 0 1 1 .706.708L12.706 11H17.5a.5.5 0 1 1 0 1h-4.793l3.39 3.388a.5.5 0 1 1-.708.707L12 12.707V17.5a.5.5 0 0 1-1 0v-4.793l-3.39 3.39a.5.5 0 1 1-.706-.708L10.293 12H5.5a.5.5 0 0 1 0-1h4.793l-3.39-3.39a.5.5 0 1 1 .708-.706L11 10.293V5.5a.5.5 0 0 1 .5-.5",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24CountStar };

//# sourceMappingURL=icon-24-count-star.js.map